var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-resumo-pacientes"},[_vm._m(0),(_vm.resumo)?_c('div',[(_vm.resumo.quantidadeCadastros > 0)?_c('apexchart',{attrs:{"type":"donut","height":"300","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-resumo-pacientes"},[_c('span',[_vm._v("Pacientes cadastrados")])])
}]

export { render, staticRenderFns }